import Swiper from 'swiper';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

function getParameterByName(name) {
  var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

// PhotoSwipe

var initPhotoSwipeFromDOM = function(gallerySelector) {
  // parse slide data (url, title, size ...) from DOM elements
  // (children of gallerySelector)
  var parseThumbnailElements = function(el) {
    var thumbElements = el.childNodes,
      numNodes = thumbElements.length,
      items = [],
      figureEl,
      linkEl,
      size,
      item;

    for (var i = 0; i < numNodes; i++) {
      figureEl = thumbElements[i]; // <figure> element

      // include only element nodes
      if (figureEl.nodeType !== 1) {
        continue;
      }

      linkEl = figureEl.children[0]; // <a> element

      size = linkEl.getAttribute('data-size').split('x');

      // create slide object
      item = {
        src: linkEl.getAttribute('href'),
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10),
      };

      if (figureEl.children.length > 1) {
        // <figcaption> content
        item.title = figureEl.children[1].innerHTML;
      }

      if (linkEl.children.length > 0) {
        // <img> thumbnail element, retrieving thumbnail url
        item.msrc = linkEl.children[0].getAttribute('src');
      }

      item.el = figureEl; // save link to element for getThumbBoundsFn
      items.push(item);
    }

    return items;
  };

  // find nearest parent element
  var closest = function closest(el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn));
  };

  // triggers when user clicks on thumbnail
  var onThumbnailsClick = function(e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : (e.returnValue = false);

    var eTarget = e.target || e.srcElement;

    // find root element of slide
    var clickedListItem = closest(eTarget, function(el) {
      return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
    });

    if (!clickedListItem) {
      return;
    }

    // find index of clicked item by looping through all child nodes
    // alternatively, you may define index via data- attribute
    var clickedGallery = clickedListItem.parentNode,
      childNodes = clickedListItem.parentNode.childNodes,
      numChildNodes = childNodes.length,
      nodeIndex = 0,
      index;

    for (var i = 0; i < numChildNodes; i++) {
      if (childNodes[i].nodeType !== 1) {
        continue;
      }

      if (childNodes[i] === clickedListItem) {
        index = nodeIndex;
        break;
      }
      nodeIndex++;
    }

    if (index >= 0) {
      // open PhotoSwipe if valid index found
      openPhotoSwipe(index, clickedGallery);
    }
    return false;
  };

  // parse picture index and gallery index from URL (#&pid=1&gid=2)
  var photoswipeParseHash = function() {
    var hash = window.location.hash.substring(1),
      params = {};

    if (hash.length < 5) {
      return params;
    }

    var vars = hash.split('&');
    for (var i = 0; i < vars.length; i++) {
      if (!vars[i]) {
        continue;
      }
      var pair = vars[i].split('=');
      if (pair.length < 2) {
        continue;
      }
      params[pair[0]] = pair[1];
    }

    if (params.gid) {
      params.gid = parseInt(params.gid, 10);
    }

    return params;
  };

  var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
    var pswpElement = document.querySelectorAll('.pswp')[0],
      gallery,
      options,
      items;

    items = parseThumbnailElements(galleryElement);

    // define options (if needed)
    options = {
      // define gallery index (for URL)
      galleryUID: galleryElement.getAttribute('data-pswp-uid'),

      getThumbBoundsFn: function(index) {
        // See Options -> getThumbBoundsFn section of documentation for more info
        var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
          pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
          rect = thumbnail.getBoundingClientRect();

        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      },
    };

    // PhotoSwipe opened from URL
    if (fromURL) {
      if (options.galleryPIDs) {
        // parse real index when custom PIDs are used
        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        for (var j = 0; j < items.length; j++) {
          if (items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        // in URL indexes start from 1
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    // exit if index not found
    if (isNaN(options.index)) {
      return;
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    // Pass data to PhotoSwipe and initialize it
    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };

  // loop through all gallery elements and bind events
  var galleryElements = document.querySelectorAll(gallerySelector);

  for (var i = 0, l = galleryElements.length; i < l; i++) {
    galleryElements[i].setAttribute('data-pswp-uid', i + 1);
    galleryElements[i].onclick = onThumbnailsClick;
  }

  // Parse URL and open gallery if it contains #&pid=3&gid=1
  var hashData = photoswipeParseHash();
  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
  }
};

export default {
  init() {
    // JavaScript to be fired on all pages  
  },
  finalize() {
      
    function shouldHideEvent(timeFilterValue, earliestAllowedStartDate, startDate) {
      if (timeFilterValue == 'upcoming') {
        return startDate.isBefore(earliestAllowedStartDate);
      }

      let latestDate = earliestAllowedStartDate.add(1, 'month');
      // Adding a second as shouldHideEvent() is checking if date is between not is same or between.
      startDate = startDate.add(1, 'second');
      
      return !startDate.isBetween(earliestAllowedStartDate, latestDate);
    }

    //menu fix
    // 1st click, add "clicked" class, preventing the location change. 2nd click will go through.
    $('.mobile-menu__link, .mobile-menu__sub-link').click(function(event) {
      // Perform a reset - Remove the "clicked" class on all other menu items
      $(this).toggleClass('clicked');
      if ($(this).hasClass('clicked')) {
        event.preventDefault();
      }
    });

    //-----------//
    //--SEARCH--//
    //---------//

    let searchToggles = document.querySelectorAll('.toggle-search');
    //let searchForm = document.querySelector('.search-form');
    let searchForm = document.getElementById("search-form-overlay");

    searchToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        searchForm.classList.toggle('hidden');
        searchForm.classList.toggle('active');
      });
    });

    // Press esc to hide search form
    window.addEventListener('keydown', function(e) {
      if(searchForm.classList.contains('active') && e.key === "Escape") {
        searchForm.classList.toggle('hidden');
        searchForm.classList.toggle('active');
        e.preventDefault();
        return false;
      }
    }, true);
    

    // JavaScript to be fired on all pages, after page specific JS is fired
    new Swiper('.block--swiper', {
      loop: true,
      speed: 800,
      spaceBetween: 0,
      centeredSlides: true,
      loopAdditionalSlides: 4,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 8000,
      },
    });

    let blocks = document.querySelectorAll('.block--faq');
    blocks.forEach(function(block) {
      block.querySelectorAll('.block--faq__question').forEach(function(question) {
        question.addEventListener('click', e => {
          let active = block.querySelector('.active');
          if (active) active.classList.remove('active');
          if (e.target != active) e.target.classList.add('active');
        });
      });
    });

    //photoswipe
    initPhotoSwipeFromDOM('.block--gallery__gallery');
    let GalleryButtons = document.querySelectorAll('.btn--gallery');
    GalleryButtons.forEach(galleryButton => {
      galleryButton.addEventListener('click', e => {
        let btn = e.target.parentNode.parentNode.querySelector(
          '.block--gallery__image .block--gallery__image__img'
        );
        btn.click();
      });
    });




	//------------------------//
	//-----EVENTS FILTER-----//
	//----------------------//
    let eventLists = document.querySelectorAll('.block--event-list');
    
    if (eventLists) {
      eventLists.forEach(el => {
        //get all elements
        let nextEl = el.nextElementSibling;
        let children = nextEl.querySelectorAll('.block--latest-posts__list > *');
        let listChildren = nextEl.nextElementSibling.querySelectorAll(
          '.block--event-list--list__row--item'
        );

        //create view switcher
        let switcher = document.createElement('a');
        switcher.setAttribute('id', 'btn--zcb-view');
        switcher.classList.add('view-switcher');
        switcher.addEventListener('click', e => {
          if (window.view == 'grid') {
            window.view = 'list';
          } else {
            window.view = 'grid';
          }
          filter(e.target);
        });
        //create filter function
        let filter = e => {
          //get parent
          let container = e.parentNode;

          let EventType = container.querySelector('.eventTypeFilter').value;
          let EventCatagory = container.querySelector('.catagoryFilter').value;

          // Hides the category filter based on event type and reset the category filter
          if (EventType == 'Short Course') {
            container.querySelector('.catagoryFilter').parentNode.classList.remove('hidden');
          } else {
            container.querySelector('.catagoryFilter').parentNode.classList.add('hidden');
            container.querySelector('.catagoryFilter').value = 'All';
            EventCatagory == 'All';
          }

          //get all filters
          let timeFilterValue = container.querySelector('.timeFilter').value;

          let earliestAllowedStartDate = dayjs(new Date())
            .startOf('month')
            .subtract(1, 'second');

          if (timeFilterValue != 'upcoming') {
            earliestAllowedStartDate = dayjs(timeFilterValue);
          }

          //hide grid / list if not on that view
          if (window.view == 'list') {
            nextEl.nextElementSibling.classList.remove('hidden');
            nextEl.classList.add('hidden');
            switcher.classList.remove('view-switcher--grid');
            switcher.classList.add('view-switcher--list');
            container.querySelector('.timeFilter').parentNode.classList.add('hidden');

            // Set timeout to make sure all the code above has ran before runnning this.
            setTimeout(function() {
              let allTitles = document.querySelectorAll('.block--event-list--list__title');
              for (let i = 0; i < allTitles.length; i++) {
                let titleContainer = allTitles[i].parentNode;
                let events = titleContainer.querySelectorAll('div:not(.hidden)');

                if (events.length < 1) {
                  titleContainer.classList.add('hidden');
                } else {
                  titleContainer.classList.remove('hidden');
                }
              }
            }, 0);
          } else if (window.view == 'grid') {
            nextEl.classList.remove('hidden');
            nextEl.nextElementSibling.classList.add('hidden');
            switcher.classList.remove('view-switcher--list');
            switcher.classList.add('view-switcher--grid');
            container.querySelector('.timeFilter').parentNode.classList.remove('hidden');
          }

          //Enable all following elements
          children.forEach(item => {
            //make visible
            item.classList.remove('hidden');

            //get startDate 
            let startDate = dayjs(item.dataset.startdate);
            //let endDate = dayjs(item.dataset.enddate);

            let shouldHideEventResult = shouldHideEvent(
              timeFilterValue,
              earliestAllowedStartDate,
              startDate
            );

            if (shouldHideEventResult) {
              item.classList.add('hidden');
            }

            if (EventType != 'All') {
              let isSelectedType = JSON.parse(item.dataset.eventtype).indexOf(EventType) >= 0;

              if (!isSelectedType) item.classList.add('hidden');
            }

            if (EventCatagory != 'All') {
              let isSelectedType =
                JSON.parse(item.dataset.catagories).indexOf(EventCatagory) >= 0;

              if (!isSelectedType) item.classList.add('hidden');
            }
          });

          listChildren.forEach(item => {
            item.classList.remove('hidden');
            if (EventType != 'All') {
              let isSelectedType = JSON.parse(item.dataset.eventtype).indexOf(EventType) >= 0;

              if (!isSelectedType) item.classList.add('hidden');
            }
            if (EventCatagory != 'All') {
              let isSelectedType =
                JSON.parse(item.dataset.catagories).indexOf(EventCatagory) >= 0;

              if (!isSelectedType) item.classList.add('hidden');
            }
          });
          setVars();
        };

        //create date filter
        let dates = [];
        //get all filled dates
        children.forEach(item => {
          let date = dayjs(item.dataset.startdate).startOf('month');
          let thismonth = dayjs()
            .startOf('month')
            .subtract(1, 'second');
          if (
            date.isAfter(thismonth) &&
            dates.filter(el => {
              return el.unix() == date.unix();
            }).length == 0
          )
            dates.push(date);
        });
        //sort dates
        dates = dates.sort((a, b) => {
          return a.unix() > b.unix();
        });
        //create filter wrapper
        let wrapper = document.createElement('div');
        wrapper.classList.add('filter_wrapper');
        //create filter label
        let label = document.createElement('label');
        label.htmlFor = 'timeFilter';
        label.innerText = el.dataset.datelabel;
        //add the wrapper and label to the page
        el.appendChild(wrapper);
        wrapper.appendChild(label);
        //build the filter element
        let timeFilter = document.createElement('select');
        wrapper.appendChild(timeFilter);
        dates.forEach(date => {
          let dateEl = document.createElement('option');
          dateEl.value = date.format('YYYY-MM-DD');
          dateEl.text = date.format('MMMM YYYY');
          timeFilter.appendChild(dateEl);
        });

        /* upcoming option */
        let dateEl = document.createElement('option');
        dateEl.value = 'upcoming';
        dateEl.text = 'Upcoming';
        let firstChild = timeFilter.firstChild;
        timeFilter.insertBefore(dateEl, firstChild);
        /* end upcoming option */

        timeFilter.name = 'timeFilter';
        timeFilter.classList.add('timeFilter');
        timeFilter.addEventListener('change', e => {
          filter(e.target.parentNode);
        });

        //create event type list
        let eventTypeList = ['All'];
        children.forEach(item => {
          let eventTypes = JSON.parse(item.dataset.eventtype);
          eventTypes.forEach(eventType => {
            let isUnique =
              eventTypeList.filter(el => {
                return el == eventType;
              }).length == 0;

            if (isUnique) eventTypeList.push(eventType);
          });
        });
        //create filter wrapper
        let eventTypeWrapper = document.createElement('div');
        eventTypeWrapper.classList.add('filter_wrapper');
        //create filter label
        let eventTypeLabel = document.createElement('label');
        eventTypeLabel.htmlFor = 'eventType';
        eventTypeLabel.innerText = el.dataset.typelabel;
        //add the wrapper and label to the page
        el.appendChild(eventTypeWrapper);
        eventTypeWrapper.appendChild(eventTypeLabel);
        //build the filter element
        let eventTypeFilter = document.createElement('select');
        eventTypeWrapper.appendChild(eventTypeFilter);
        eventTypeList.forEach(eventType => {
          let eventTypeEl = document.createElement('option');
          eventTypeEl.value = eventType;
          eventTypeEl.text = eventType;
          eventTypeFilter.appendChild(eventTypeEl);
        });
        eventTypeFilter.name = 'eventTypeFilter';
        eventTypeFilter.classList.add('eventTypeFilter');
        eventTypeFilter.addEventListener('change', e => {
          filter(e.target.parentNode);
        });

        //create catagory list
        let catagoryList = ['All'];
        children.forEach(item => {
          let catagories = JSON.parse(item.dataset.catagories);
          catagories.forEach(catagory => {
            let isUnique =
              catagoryList.filter(el => {
                return el == catagory;
              }).length == 0;

            if (isUnique) catagoryList.push(catagory);
          });
        });
        //create filter wrapper
        let catagoryWrapper = document.createElement('div');
        catagoryWrapper.classList.add('filter_wrapper');
        //create filter label
        let catagoryLabel = document.createElement('label');
        catagoryLabel.htmlFor = 'catagory';
        catagoryLabel.innerText = el.dataset.catagorylabel;
        //add the wrapper and label to the page
        el.appendChild(catagoryWrapper);
        catagoryWrapper.appendChild(catagoryLabel);
        //build the filter element
        let catagoryFilter = document.createElement('select');
        catagoryWrapper.appendChild(catagoryFilter);
        catagoryList.forEach(catagory => {
          let catagoryEl = document.createElement('option');
          catagoryEl.value = catagory;
          catagoryEl.text = catagory;
          catagoryFilter.appendChild(catagoryEl);
        });
        catagoryFilter.name = 'catagoryFilter';
        catagoryFilter.classList.add('catagoryFilter');
        catagoryFilter.addEventListener('change', e => {
          filter(e.target.parentNode);
        });

        //create save and load filter functions
        let setVars = () => {
          let url = window.location.href;
          if (url.indexOf('?') != -1) {
            url = url.split('?')[0];
          }
          window.history.replaceState(
            {},
            document.title,
            url +
              '?date=' +
              el.querySelector('.timeFilter').value +
              '&view=' +
              window.view +
              '&type=' +
              eventTypeFilter.value.replace(/ /g, '-') +
              '&category=' +
              catagoryFilter.value.replace(/ /g, '-')
          );
        };

        let loadvars = () => {
          let date = getParameterByName('date');
          let view = getParameterByName('view');
          let eventType = getParameterByName('type');
          let catagory = getParameterByName('category');
          if (date) {
            timeFilter.value = date;
            timeFilter.text = dayjs(date).format('MMMM YYYY');
          }
          if (eventType) {
            eventType = eventType.replace(/-/g, ' ');
            eventTypeFilter.value = eventType;
            eventTypeFilter.text = eventType;
          }
          if (catagory) {
            catagory = catagory.replace(/-/g, ' ');
            catagoryFilter.value = catagory;
            catagoryFilter.text = catagory;
          }
          if (view) {
            window.view = view;
          } else {
            window.view = 'grid';
          }
          filter(timeFilter.parentNode);
        };

        //add switcher last before running loadvars
        el.appendChild(switcher);

        loadvars();
      });
    }
    
    
	//---------------------//
	//-----ZCB FILTER-----//
	//-------------------//
    let zcbLists = document.querySelectorAll('.block--zcb-list');
    
    let query = new XMLHttpRequest();
        
        query.addEventListener('load', function() {
            document.getElementById('no-results-notice').classList.add('hidden');
            let posts;
            
            if (query.status == 200) {
                posts = JSON.parse(query.responseText);
            } else {
                document.getElementsByClassName('block--latest-posts__status')[0]
                  .classList.add('block--latest-posts__status-error');
                document.getElementsByClassName('block--latest-posts__status')[0]
                  .classList.remove('block--latest-posts__status-loading');
                return;
            }

            posts.forEach(function(post) {
                // These variables are created in filters.php
                let article = document.createElement('article');
                article.classList.add('block--latest-posts__post');
                
                let offset = document.createElement('div');
                offset.classList.add('block--offset');

                let background = document.createElement('div');
                background.classList.add('block--offset__background');
                
                let imgLink = document.createElement('a');
                imgLink.href = post.link;
                imgLink.target = '_blank';
                
                let img = document.createElement('img');
                img.src = post.featured_media_url;
                img.alt = post.featured_media_alt;
                if (post.featured_media_url == null) {
                    img.src = post.default_card_image_url;
                    img.alt = post.default_card_image_alt;
                }
                
                let card = document.createElement('div');
                card.classList.add('block--offset__card');
                
                let cardTitle = document.createElement('h1');
                cardTitle.classList.add('block--offset__title--no-underline');
                
                let cardTitleLink = document.createElement('a');
                cardTitleLink.href = post.link;
                cardTitleLink.target = '_blank';
                cardTitleLink.textContent = post.title;
                
                let postText = document.createElement('p');
                postText.classList.add('block--latest-posts__post__body');
                
                let dateText = document.createElement('span');
                dateText.classList.add('block--latest-posts__post__date');
                dateText.textContent = post.start_date;
                
                if (post.cat_header) {
                    postText.textContent = post.cat_header;
                } else if (post.detail_from_source) {
                     postText.textContent = post.detail_from_source;
                } else if (post.excerpt) {
                    postText.textContent = post.excerpt;
                } else {
                    postText.textContent = post.meta_description;
                }
                
                let link = document.createElement('a');
                link.classList.add('btn');
                link.classList.add('btn--green-outline');
                if (post.directly_link) {
                    link.href = post.resource_link;
                    link.target = '_blank';
                    link.textContent = 'Go to Link';
                } else {
                    link.href = post.link;
                    link.target = '_blank';
                    link.textContent = 'Read More';
                }
                
                article.appendChild(offset);
                offset.appendChild(background);
                background.appendChild(imgLink);
                imgLink.appendChild(img);
                offset.appendChild(card);
                card.appendChild(cardTitle);
                cardTitle.appendChild(cardTitleLink);
                article.appendChild(postText);
                article.appendChild(link);
                postText.prepend(dateText);

                document.getElementsByClassName('block--latest-posts__list')[0].appendChild(article);
            });
            document.getElementsByClassName('block--latest-posts__status')[0].classList.add('hidden');
            document.getElementById('btn--zcb-load').classList.remove('hidden');
            if (document.getElementsByClassName('block--latest-posts__list')[0].childNodes.length == 0) {
                document.getElementById('no-results-notice').classList.remove('hidden');
                document.getElementById('btn--zcb-load-wrapper').classList.add('hidden');
            } else {
                document.getElementById('btn--zcb-load-wrapper').classList.remove('hidden');
            }
            let test1 = query.getResponseHeader('X-WP-TotalPages');
            let test2 = document.getElementById('zcb-filter-page').value;
            test1; test2;
            if (parseInt(query.getResponseHeader('X-WP-TotalPages')) 
              <= parseInt(document.getElementById('zcb-filter-page').value)) {
                document.getElementById('btn--zcb-load-wrapper').classList.add('hidden');
            } else {
                document.getElementById('btn--zcb-load-wrapper').classList.remove('hidden');
            }
        });
        
        function loadNextPage() {
            document.getElementById('zcb-filter-page').value =
              parseInt(document.getElementById('zcb-filter-page').value) + 1;
            document.getElementsByClassName('block--latest-posts__status')[0].classList.remove('hidden');
            document.getElementsByClassName('block--latest-posts__status')[0]
                  .classList.remove('block--latest-posts__status-error');
            document.getElementsByClassName('block--latest-posts__status')[0]
                  .classList.add('block--latest-posts__status-loading');
            let jsonUrl = '/wp-json/wp/v2/external_resource?per_page=12';
            let jsonQuery = getJsonQuery();
            if (jsonQuery) {
                window.history.replaceState(null, '', window.location.href.split('?')[0] + '?' + jsonQuery.slice(1));
            } else {
                window.history.replaceState(null, '', window.location.href.split('?')[0]);
            }
            
            query.open('GET', jsonUrl + jsonQuery, true);
            query.send();
            return false;
        }
        
        /* eslint-disable no-unused-vars */
        function getJsonQuery() {
            let jsonQuery = '';
            [].forEach.call(document.getElementsByClassName('zcb-filter'), function(zcbSelect) {
                if (zcbSelect.value) {
                    jsonQuery += '&' + zcbSelect.name + '=' + zcbSelect.value;
                }
            });
            return jsonQuery;
        }
        
        function onChangeViewClick(e) {
            if (e.currentTarget.classList.contains('view-switcher--list')) {
                changeViewStyle('grid');
            } else {
                changeViewStyle('list')
            }
            
            return false;
        }
        
        function changeViewStyle(style) {
            if (style == 'grid') {
                document.getElementsByClassName('block--latest-posts__list')[0]
                  .classList.add('block--latest-posts__list-grid');
                document.getElementsByClassName('block--latest-posts__list')[0]
                  .classList.remove('block--latest-posts__list-list');
                document.getElementById('btn--zcb-view').classList.remove('view-switcher--list');
                document.getElementById('btn--zcb-view').classList.add('view-switcher--grid');
            } else {
                document.getElementsByClassName('block--latest-posts__list')[0]
                  .classList.add('block--latest-posts__list-list');
                document.getElementsByClassName('block--latest-posts__list')[0]
                  .classList.remove('block--latest-posts__list-grid');
                document.getElementById('btn--zcb-view').classList.remove('view-switcher--grid');
                document.getElementById('btn--zcb-view').classList.add('view-switcher--list');
            }
        }
        
        function changeZcbFilter(isNavigated = false) {
            //event;
            //alert("Changing filter...");
            document.getElementById('btn--zcb-load').classList.add('hidden');
            document.getElementsByClassName('block--latest-posts__status')[0].classList.remove('hidden');
            document.getElementsByClassName('block--latest-posts__status')[0]
                  .classList.remove('block--latest-posts__status-error');
            document.getElementsByClassName('block--latest-posts__status')[0]
                  .classList.add('block--latest-posts__status-loading');
            document.getElementsByClassName('block--latest-posts__list')[0].innerHTML = '';
            document.getElementById('zcb-filter-page').value = 1;
            let jsonUrl;
            if (isNavigated) {
                jsonUrl = '/wp-json/wp/v2/external_resource?per_page=' + 
                  (12 * parseInt(document.getElementById('zcb-filter-page').value));
            } else {
                jsonUrl = '/wp-json/wp/v2/external_resource?per_page=12';
            }
            
            let jsonQuery = getJsonQuery();
            if (jsonQuery) {
                window.history.replaceState(null, '', window.location.href.split('?')[0] + '?' + jsonQuery.slice(1));
            } else {
                window.history.replaceState(null, '', window.location.href.split('?')[0]);
            }
            
            query.open('GET', jsonUrl + jsonQuery, true);
            query.send();
        }
        
        if (zcbLists.length != 0) {
            let getVars = [];
            
            let splitAddress = window.location.search.split('?');
            if (splitAddress.length == 2) {
                window.location.search.split('?')[1].split('&').forEach(function (newVar) {
                    getVars.push(newVar.split('='));
                });
            }
            
            // Filter Functions
            [].forEach.call(document.getElementsByClassName('zcb-filter'), function(zcbSelect) {
                getVars.forEach(function (curVar) {
                    if (curVar[0] == zcbSelect.name) {
                        console.log(zcbSelect.tagName);
                        if (zcbSelect.tagName == 'SELECT') {
                            [].every.call(zcbSelect.options, function (option) {
                                if (typeof curVar[1] == 'undefined' || curVar[1] == '' || curVar[1] == 'All') { return false; }
                                if (curVar[1] == option.value) {
                                    option.selected = true;
                                    return false;
                                }
                                return true;
                            });
                        } else if (zcbSelect.tagName == 'INPUT') {
                            zcbSelect.value = curVar[1];
                        }
                    } else if (curVar[0] == 'view') {
                        changeViewStyle(curVar[1]);
                    }
                });
                zcbSelect.onchange = changeZcbFilter;
            });
            
            
            if (document.getElementById('btn--zcb-view').classList.length == 1) {
                changeViewStyle('grid');
            }
            
            document.getElementById('btn--zcb-load').onclick = loadNextPage;
            document.getElementById('btn--zcb-view').onclick = onChangeViewClick;
            
            changeZcbFilter(true);
        }

    //----- END ZCB FILTER -----//    
    
    
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js